import React, { FC, useCallback } from 'react';

import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import { Article } from '../../../../models/Article';
import { ProductMetaData } from '../../../../models/Product';
import { useReserveListItemCopies } from '../useReserveListItemCopies';
import { CopiesListDropdown } from '../../../shared/product/CopiesListDropdown';
import { CopiesList } from '../../../shared/product/CopiesList';
import { AppState } from '../../../store/appState';
import * as types from '../../../store/constants';

import './ReserveListItemCopyDetails.scss';

type Props = {
    readonly product: ProductMetaData & Article;
    readonly onCopyAmountChange?: (productId: string, amount: number, command: string) => void;
};

export const ReserveListItemCopyDetails: FC<Props> = props => {
    return (
        <CopiesListDropdown className="reserve-list-item-copy-details">
            <ReserveListItemCopyList {...props} />
        </CopiesListDropdown>
    );
};

const ReserveListItemCopyList: FC<Props> = props => {
    const {
        product: { id: productId, loanFormat, price },
        onCopyAmountChange
    } = props;

    const { reserveListId } = useParams<{ readonly reserveListId: string }>();
    const { taxName } = useSelector((state: AppState) => state.authentication.spoc);
    const { status, copies } = useReserveListItemCopies({ reserveListId, productId });
    const handleRemove = useCallback(() => {
        onCopyAmountChange?.(productId, 1, types.ACTION_DECREASE);
    }, [onCopyAmountChange, productId]);

    return (
        <CopiesList
            loanFormat={loanFormat}
            netValue={price?.netValue}
            currency={price?.currency}
            taxName={taxName}
            copies={copies}
            loading={status === 'loading'}
            disabled={!(props.product as any).accepted}
            onRemove={handleRemove}
            removeCopyHint="Remove copy from reserve report."
        />
    );
};
